// Constants
import { INITIALIZE_UPCOMING_EVENTS, UPCOMING_EVENTS_LOADING } from "@/store/actions/upcomingEventsActions";
const initialState = { loading: true, data: [] };

const upcomingEventsReducer = (state = initialState, action) => {
    if (action.type === UPCOMING_EVENTS_LOADING) {
        return {
            ...state,
            loading: true,
        };
    } else if (action.type === INITIALIZE_UPCOMING_EVENTS) {
        return {
            ...state,
            data: action.payload,
            loading: false,
        };
    } else {
        return state;
    }
};

export default upcomingEventsReducer;
